<script> 
	import TBoxInterno from '../templates/TBoxInterno.svelte';

	let resultadoBusca = [];
	let { json: { dados } } = JSON.parse(localStorage.getItem('AVAL_LISTAGEM_PROJETOS_CACHE_PG9999'));
	resultadoBusca = dados;
</script>

<style>
.container_tabela {
	overflow-x: auto;
}
</style>

<TBoxInterno 
	titulo="Resultado da Busca" 
	subtitulo="..."
	largura="10" 
	icone="buscar"
	deslocamento="1">

	<div class="container_tabela">
		<table class="table is-fullwidth is-hoverable">
			<thead>
				<tr>
					<th>#</th>
					<th>Cód.</th>
					<th>Título</th>
					<th>Modalidade</th>
				</tr>
			</thead>
			<tbody>
				{#each resultadoBusca as valor, i}
				<tr>
					<th>{ ++i }</th> 
					<td><a href="#/projeto/visualizar/{valor.codigo}">{ valor.codigo }</a></td>
					<td>{ valor.titulo }</td>
					<td>{ valor.modalidade }</td>
				</tr>
				{/each}
			</tbody>
		</table>
	</div>
</TBoxInterno>